import script from "./ProductListing.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductListing.vue?vue&type=script&setup=true&lang=js"

import "./ProductListing.vue?vue&type=style&index=0&id=5bb7cef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb7cef4"]])

export default __exports__